// extracted by mini-css-extract-plugin
module.exports = {"root":"IconCalendar_root__1hlCi"};